<app-steps-header></app-steps-header>

<app-welcome
	*ngIf="this.currentPage == 'welcome'"
	(termsAccepted)="activateContinue($event)"
	[activateCheck]="activateCheck"
></app-welcome>

<app-about-zenoffice
	*ngIf="this.currentPage == 'about-zenoffice'"
></app-about-zenoffice>

<app-subscription-data
	*ngIf="this.currentPage == 'subscription-data'"
	(formContent)="pickFormData($event)"
	(formIsValid)="activateContinue($event)"
></app-subscription-data>

<app-choose-plan *ngIf="this.currentPage == 'choose-plan'"></app-choose-plan>

<app-wizard-navigation
	(currentStepItem)="changePage($event)"
	(termsAlreadyAccepted)="activateCheckbox($event)"
	[activateBtn]="activateBtn"
></app-wizard-navigation>

